import axios from 'axios';
import { times } from 'lodash';
import { defineStore } from 'pinia';
import { authStore } from '../stores/auth';

export const userStore = defineStore('user-store', {
    state: () => {
        return {
            userData: '',
            creatingAccount: false,
            errorCreatingAccount: false,
            updatingAccount: false,
            errorCreatingAccount: false,
            updated: false,
        };
    },

    getters: {
        userProfile(state) {
            return state.userData;
        },

        isUpdating(state) {
            return state.updatingAccount;
        },

        isUpdated(state) {
            return state.updated;
        },

        isCreatingAccount(state) {
            return state.creatingAccount;
        },

        hasErrorCreatingAccount(state) {
            return state.errorCreatingAccount;
        },
    },

    actions: {
        async fetchUserData() {
            this.updated = false;
            //Do the request
            const response = await axios.get(
                process.env.VUE_APP_API_BASE_URL + 'applicants/me?',
                authStore().authConfig,
            );
            try {
                this.userData = response.data;
            } catch (err) {
                this.userData = '';
                console.error('Error loading Invoices:', err);
                return err;
            }
        },

        async changePassword(oldPassword, newPassword) {
            this.updatingAccount = true;
            const response = await axios.post(
                process.env.VUE_APP_API_BASE_URL + 'applicants/me/changepassword',
                {
                    oldPassword: oldPassword,
                    newPassword: newPassword,
                },
                authStore().authConfig,
            );
            try {
                if (response.status === 204) {
                    this.updatingAccount = false;
                    this.updated = true;
                }
            } catch (err) {
                console.error('Failed to update the account:', err);
                return err;
            }
        },

        async updateUserProfile(contactData, queuesData) {
            this.updatingAccount = true;
            const response = await axios.put(
                process.env.VUE_APP_API_BASE_URL + 'applicants/me',
                {
                    contactData: contactData,
                    queuesData: queuesData,
                    userType: 'person',
                },
                authStore().authConfig,
            );
            try {
                if (response.data.contactCode) {
                    //
                    this.updatingAccount = false;
                    this.updated = true;
                }
            } catch (err) {
                console.error('Failed to update the account:', err);
                this.updatingAccount = false;
                return err;
            }
        },

        async createNewUser(contactData, applicationData, queuesData) {
            //Start the loader
            this.creatingAccount = true;
            this.errorCreatingAccount = false;

            //Cleanup (let the user type the civic number with dashes but remove them before sending)
            contactData.civicNumber = contactData.civicNumber.replaceAll('-', '').trim();
            //Add the other datasets. After refactoring
            contactData.applicationData = applicationData;
            contactData.queuesData = queuesData;

            try {
                //Do the request.
                const response = await axios.post(process.env.VUE_APP_API_BASE_URL + 'applicants', contactData);

                if (!response.data.contactCode) {
                    throw new Error('No contact code in response');
                }

                //Log in the user
                await authStore().signInUser({
                    userName: contactData.civicNumber,
                    password: contactData.password,
                    timeToLive: 0,
                });
                //Fetch the users data
                await this.fetchUserData();
            } catch (err) {
                console.error('Failed to create account:', err);
                this.errorCreatingAccount = true;
                return err;
            } finally {
                //Always hide the loader, whether it succeeded or failed
                this.creatingAccount = false;
            }
        },
    },
});
